import { number, oneOfType, string } from "prop-types";
import { useSelector } from "react-redux";

import { useDataCachedAttributes } from "web/hooks/useDataCached";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

const LocationParent = ({ location, className }) => {
  const { token, id: storeId } = useSelector((state) => state.app.storeConfig);
  const { loading, error, data } = useDataCachedAttributes({
    ids: ["location_location_parent_location_parent"],
    storeId,
    token,
  });

  if (loading || error) {
    return null;
  }

  const currentOptions =
    isArrayHasItems(data) &&
    data[0] &&
    isArrayHasItems(data[0].attribute_options) &&
    data[0].attribute_options.filter(
      (option) => option && location.indexOf(option.value) !== -1
    );
  const locationLabels =
    currentOptions && isArrayHasItems(currentOptions)
      ? currentOptions.map((option) => (option ? option.label : ""))
      : "";

  return locationLabels ? (
    <div
      className={className}
      data-t1="location_parent_label"
      data-t2={locationLabels}
    >
      {locationLabels}
    </div>
  ) : null;
};

LocationParent.propTypes = {
  location: oneOfType([string, number]).isRequired,
  className: string,
};

LocationParent.defaultProps = {
  className: "",
};

export default LocationParent;
